// extracted by mini-css-extract-plugin
export default {"root":"checkboxes_item-module___root___a1e18b59"};